import "core-js/modules/es.array.iterator.js";
import { useDrag } from '@use-gesture/react';
import { isMobile } from '@isyc-react/core/device';
import { getParentPageElement } from "./page.utils";
export const useDragPan = (scale, active) => {
  const dragPan = useDrag(drag => {
    const {
      direction: [dirX, dirY],
      movement: [movX, movY]
    } = drag;
    const target = drag.event.target;
    const parent = getParentPageElement(target);
    if (!isMobile && active && parent) {
      const maxMov = 750;
      const movAbs = Math.max(Math.abs(movX), Math.abs(movY), maxMov);
      const movFactor = movAbs / maxMov + 1;
      const factor = 8 * scale * movFactor;
      const initScrollX = parent.scrollLeft;
      const maxScrollX = parent.scrollWidth;
      const initScrollY = parent.scrollTop;
      const maxScrollY = parent.scrollHeight;
      let scrollY = initScrollY;
      let scrollX = initScrollX;
      if (dirY > 0) {
        scrollY = Math.max(initScrollY - factor, 0);
      } else if (dirY < 0) {
        scrollY = Math.min(initScrollY + factor, maxScrollY);
      }
      if (dirX > 0) {
        scrollX = Math.max(initScrollX - factor, 0);
      } else if (dirX < 0) {
        scrollX = Math.min(initScrollX + factor, maxScrollX);
      }
      parent.scrollLeft = scrollX;
      parent.scrollTop = scrollY;
    }
  });
  return dragPan;
};